var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { useDimensions } from "../utils/useDimensions";
var ScreenWrapper = function (_a) {
    var children = _a.children, sx = _a.sx, noPadding = _a.noPadding;
    var dimensions = useDimensions();
    return (_jsx(Box, __assign({ flexDirection: 'column', sx: __assign({ width: '100%', position: 'relative', '@media print': {
                display: 'block',
                padding: '0',
                '::-webkit-scrollbar': {
                    display: 'none'
                }
            } }, sx === null || sx === void 0 ? void 0 : sx.root) }, { children: _jsx(Box, __assign({ sx: __assign({ width: '100%', paddingTop: noPadding ? 0 : "24px", paddingBottom: noPadding ? 0 : '24px', paddingLeft: noPadding ? 0 : dimensions.commonContentPadding, paddingRight: noPadding ? 0 : dimensions.commonContentPadding, '@media print': {
                    display: 'block',
                    padding: '0',
                    '::-webkit-scrollbar': {
                        display: 'none'
                    }
                } }, sx === null || sx === void 0 ? void 0 : sx.contentHolder), display: 'flex', flexDirection: 'column' }, { children: children })) })));
};
ScreenWrapper.displayName = "ScreenWrapper";
export default ScreenWrapper;
